import * as React from 'react';
import { toast } from '@grandvisionhq/common';
import { Container } from '@grandvisionhq/elements';
import CustomerSupportFormContainer from './CustomerSupportForm/CustomerSupportFormContainer.js';
import SuccessMessageContainer from './SuccessMessage/SuccessMessageContainer.js';

const CustomerSupport = ({ onSubmit , isLoading , showErrorMessage =false , showSuccessMessage =false , isCustomerIDActivated =false , showConsent =false ,  })=>{
    React.useEffect(()=>{
        if (showErrorMessage) {
            toast.failed('customersupport.submit.error');
        }
    }, [
        showErrorMessage
    ]);
    return /*#__PURE__*/ React.createElement("section", {
        className: "customer-support",
        "data-t": "customer-support"
    }, /*#__PURE__*/ React.createElement(Container, {
        className: "customer-support__container"
    }, showSuccessMessage ? /*#__PURE__*/ React.createElement(SuccessMessageContainer, null) : /*#__PURE__*/ React.createElement(CustomerSupportFormContainer, {
        onSubmit: onSubmit,
        isLoading: isLoading,
        isCustomerIDActivated: isCustomerIDActivated,
        showConsent: showConsent
    })));
};

export { CustomerSupport as default };
//# sourceMappingURL=CustomerSupport.js.map
